import FeatureGates, { FeatureGateEnvironment } from '@atlaskit/feature-gate-js-client';
import { FeatureGatesInitialization } from '@atlassian/feature-gates-react';
import { useTenantData } from '@dev-agents/tenant-context';
import React from 'react';

import { NotFound } from '../ui/not-found';
import { useAuthData } from '../utils/auth-context';

const STATSIG_CLIENT_KEY = {
	staging: '00f6830e-2abf-458f-b2ad-10c1a238d343',
	production: 'bf14aab7-117d-45e0-98ea-1e2e5efc2c39',
};

const getEnvironment = () => {
	if (window.location.hostname.includes('atlassian.net')) {
		return 'production';
	}

	return 'staging';
};

export const fg: typeof FeatureGates.checkGate = (gateName) => {
	if (!FeatureGates.initializeCompleted() && process.env.NODE_ENV !== 'production') {
		console.log('Feature gate client has not been initialized');
	}

	return FeatureGates.checkGate(gateName);
};

export const FeatureGateClient = ({ children }: { children: React.ReactNode }) => {
	const { tenantContexts } = useTenantData();
	const { user } = useAuthData();

	const onError = (err?: Error) => {
		if (err) {
			console.error('STATSIG_CLIENT_ERROR', err);
			throw err;
		}
	};

	// If tenantContexts is empty, the user does not have access to the site.
	if (!tenantContexts?.length) {
		return <NotFound />;
	}

	if (!user?.accountId || !tenantContexts[0].cloudId) {
		throw new Error('User/Tenant Context is not set');
	}

	const apiKey = STATSIG_CLIENT_KEY[getEnvironment()];

	if (!apiKey) {
		throw new Error('STATSIG_CLIENT_API_KEY is not set');
	}

	const atlassianAccountId = user.accountId;
	const { cloudId } = tenantContexts[0];

	return (
		<FeatureGatesInitialization
			options={{
				apiKey,
				environment:
					getEnvironment() === 'staging'
						? FeatureGateEnvironment.Staging
						: FeatureGateEnvironment.Production,
				targetApp: 'dev-agents_web',
				fetchTimeoutMs: 1000,
				useGatewayURL: true,
			}}
			identifiers={{ atlassianAccountId, tenantId: cloudId }}
			onReady={onError}
		>
			{children}
		</FeatureGatesInitialization>
	);
};
